module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyrightt"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Farrar, Straus and Giroux")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("18 West 18th Street, New York 10011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2008 by Frances Wilson")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Map copyright © András Bereznay")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Originally published in 2008 by Faber and Faber Limited, Great Britain")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Published in the United States by Farrar, Straus and Giroux")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First American edition, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Owing to limitations of space, illustration credits appear on page 317.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Wilson, Frances, 1964–")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("The ballad of Dorothy Wordsworth : a life / Frances Wilson. —1st American ed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("    p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("“Originally published in 2008 by Faber and Faber Limited, Great Britain”—T.p. verso.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN-13: 978-0-374-10867-0 (alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN-10: 0-374-10867-6 (alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("1. Wordsworth, Dorothy, 1771–1855. 2. Wordsworth, William, 1770–1850—Family. 3. Authors, English—19th century—Biography. 4. Women and literature—England—History—19th century. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("PR5849.W55 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("828'.703—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("[B]")]), _vm._v(" "), _c('p', {
    staticClass: "copyright4"
  }, [_vm._v("2008041263")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Designed by Michelle McMillian")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fsgbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fsgbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1   3   5   7   9   10   8   6   4   2")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0